<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useKbd } from 'dashboard/composables/utils/useKbd';
import { useUISettings } from 'dashboard/composables/useUISettings';

const { t } = useI18n();
const { isEditorHotKeyEnabled } = useUISettings();

const replyKey = useKbd(['alt', 'L']);
const noteKey = useKbd(['alt', 'P']);
const attachKey = useKbd(['$mod', 'alt', 'A']);
const commandSendKey = useKbd(['$mod', 'enter']);
const enterSendKey = useKbd(['enter']);
const contextKey = useKbd(['alt', 'O']);
const sendKey = computed(() =>
  isEditorHotKeyEnabled('cmd_enter') ? commandSendKey.value : enterSendKey.value
);

const shortcuts = computed(() => [
  {
    label: t('INBOX.WORKSPACE.SHORTCUT.REPLY'),
    keys: replyKey.value,
  },
  {
    label: t('INBOX.WORKSPACE.SHORTCUT.NOTE'),
    keys: noteKey.value,
  },
  {
    label: t('INBOX.WORKSPACE.SHORTCUT.ATTACH'),
    keys: attachKey.value,
  },
  {
    label: t('INBOX.WORKSPACE.SHORTCUT.SEND'),
    keys: sendKey.value,
  },
  {
    label: t('INBOX.WORKSPACE.SHORTCUT.CONTEXT'),
    keys: contextKey.value,
  },
]);
</script>

<template>
  <aside
    class="items-center hidden min-w-0 gap-3 overflow-hidden xl:flex"
    :aria-label="t('INBOX.WORKSPACE.SHORTCUT.LABEL')"
  >
    <span
      v-for="shortcut in shortcuts"
      :key="shortcut.label"
      class="items-center hidden min-w-0 gap-1.5 text-[10px] text-n-slate-9 first:flex 2xl:flex"
    >
      <kbd
        class="px-1.5 py-0.5 font-sans font-medium whitespace-nowrap border rounded-md border-n-weak bg-n-alpha-2 text-n-slate-10"
      >
        {{ shortcut.keys }}
      </kbd>
      <span class="truncate">{{ shortcut.label }}</span>
    </span>
  </aside>
</template>
